import { Button, Stack } from '@mui/material';

type CustomerImportActionsProps = {
  onSelectAll: () => void;
  onDeselectAll: () => void;
};

function CustomerImportActions({
  onSelectAll,
  onDeselectAll,
}: CustomerImportActionsProps) {
  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      sx={{ mb: 2 }}
    >
      <Button size="small" onClick={onSelectAll}>
        Valitse kaikki
      </Button>
      <Button size="small" onClick={onDeselectAll}>
        Poista valinnat
      </Button>
    </Stack>
  );
}

export default CustomerImportActions;
